import { render, staticRenderFns } from "./AddColorExisting.vue?vue&type=template&id=3948ea68&scoped=true"
import script from "./AddColorExisting.vue?vue&type=script&lang=js"
export * from "./AddColorExisting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948ea68",
  null
  
)

export default component.exports